import { render, staticRenderFns } from "./CompanyIaCompanyInstructions.vue?vue&type=template&id=e5838b18&scoped=true&"
import script from "./CompanyIaCompanyInstructions.vue?vue&type=script&lang=js&"
export * from "./CompanyIaCompanyInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5838b18",
  null
  
)

export default component.exports